var map = {
	"./auth.json": "../../packages/i18n/src/de/auth.json",
	"./banners.json": "../../packages/i18n/src/de/banners.json",
	"./business-meta.json": "../../packages/i18n/src/de/business-meta.json",
	"./chat/common.json": "../../packages/i18n/src/de/chat/common.json",
	"./chat/list.json": "../../packages/i18n/src/de/chat/list.json",
	"./chat/message.json": "../../packages/i18n/src/de/chat/message.json",
	"./company/admin.json": "../../packages/i18n/src/de/company/admin.json",
	"./company/common.json": "../../packages/i18n/src/de/company/common.json",
	"./company/create.json": "../../packages/i18n/src/de/company/create.json",
	"./company/options.json": "../../packages/i18n/src/de/company/options.json",
	"./company/page.json": "../../packages/i18n/src/de/company/page.json",
	"./company/users.json": "../../packages/i18n/src/de/company/users.json",
	"./errors.json": "../../packages/i18n/src/de/errors.json",
	"./group-preview.json": "../../packages/i18n/src/de/group-preview.json",
	"./landing/companies.json": "../../packages/i18n/src/de/landing/companies.json",
	"./landing/driver.json": "../../packages/i18n/src/de/landing/driver.json",
	"./landing/exchange.json": "../../packages/i18n/src/de/landing/exchange.json",
	"./landing/meta.json": "../../packages/i18n/src/de/landing/meta.json",
	"./landing/private_exchange.json": "../../packages/i18n/src/de/landing/private_exchange.json",
	"./landing/shared.json": "../../packages/i18n/src/de/landing/shared.json",
	"./layout.json": "../../packages/i18n/src/de/layout.json",
	"./modals.json": "../../packages/i18n/src/de/modals.json",
	"./offer/actions.json": "../../packages/i18n/src/de/offer/actions.json",
	"./offer/exchange.json": "../../packages/i18n/src/de/offer/exchange.json",
	"./offer/form/cargo.json": "../../packages/i18n/src/de/offer/form/cargo.json",
	"./offer/form/common.json": "../../packages/i18n/src/de/offer/form/common.json",
	"./offer/form/options.json": "../../packages/i18n/src/de/offer/form/options.json",
	"./offer/form/transport.json": "../../packages/i18n/src/de/offer/form/transport.json",
	"./offer/matches.json": "../../packages/i18n/src/de/offer/matches.json",
	"./offer/my.json": "../../packages/i18n/src/de/offer/my.json",
	"./offer/own.json": "../../packages/i18n/src/de/offer/own.json",
	"./offer/preview.json": "../../packages/i18n/src/de/offer/preview.json",
	"./offer/shared.json": "../../packages/i18n/src/de/offer/shared.json",
	"./offer/view.json": "../../packages/i18n/src/de/offer/view.json",
	"./placeholders.json": "../../packages/i18n/src/de/placeholders.json",
	"./profile/black_list.json": "../../packages/i18n/src/de/profile/black_list.json",
	"./profile/contact_list.json": "../../packages/i18n/src/de/profile/contact_list.json",
	"./profile/edit_profile.json": "../../packages/i18n/src/de/profile/edit_profile.json",
	"./profile/fill_profile.json": "../../packages/i18n/src/de/profile/fill_profile.json",
	"./profile/my_profile.json": "../../packages/i18n/src/de/profile/my_profile.json",
	"./profile/my_profile_auth.json": "../../packages/i18n/src/de/profile/my_profile_auth.json",
	"./profile/profile_form.json": "../../packages/i18n/src/de/profile/profile_form.json",
	"./profile/shared.json": "../../packages/i18n/src/de/profile/shared.json",
	"./profile/short_profile.json": "../../packages/i18n/src/de/profile/short_profile.json",
	"./shared.json": "../../packages/i18n/src/de/shared.json",
	"./ui.json": "../../packages/i18n/src/de/ui.json",
	"./validation.json": "../../packages/i18n/src/de/validation.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../packages/i18n/src/de sync recursive \\.json$";